export default __webpack_public_path__ + "static/media/warning--falling-rocks-or-debris-left--g1.ba33de2a.png";